import { apiClient, ApiResponse } from './api'

export interface Permission {
  _id: string
  key: string
  createdAt: string
  updatedAt: string
  createdBy: string | null
  updatedBy: string | null
  deletedAt: string | null
  deletedBy: string | null
  __v: number
}

export interface PermissionsResponse {
  permissions: Permission[]
  total: number
  page: number
  limit: number
}

export interface CreatePermissionRequest {
  key: string
}

export interface UpdatePermissionRequest {
  key?: string
}

export interface GetPermissionsParams {
  page?: number
  limit?: number
  search?: string
}

export const permissionsApi = {
  /**
   * Get all permissions with pagination
   */
  async getPermissions(params?: GetPermissionsParams): Promise<ApiResponse<PermissionsResponse>> {
    try {
      const queryParams = new URLSearchParams()
      if (params?.page) queryParams.append('page', params.page.toString())
      if (params?.limit) queryParams.append('limit', params.limit.toString())
      if (params?.search) queryParams.append('search', params.search)
      
      const endpoint = `/auth-service/api/v1/permissions${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
      const response = await apiClient.get<PermissionsResponse>(endpoint, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Get permissions error:', error)
      throw error
    }
  },

  /**
   * Get permission by ID
   */
  async getPermissionById(permissionId: string): Promise<ApiResponse<Permission>> {
    try {
      const response = await apiClient.get<Permission>(`/auth-service/api/v1/permissions/${permissionId}`, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Get permission by ID error:', error)
      throw error
    }
  },

  /**
   * Create a new permission
   */
  async createPermission(permissionData: CreatePermissionRequest): Promise<ApiResponse<Permission>> {
    try {
      const response = await apiClient.post<Permission>('/auth-service/api/v1/permissions', permissionData, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Create permission error:', error)
      throw error
    }
  },

  /**
   * Update permission
   */
  async updatePermission(permissionId: string, permissionData: UpdatePermissionRequest): Promise<ApiResponse<Permission>> {
    try {
      const response = await apiClient.patch<Permission>(`/auth-service/api/v1/permissions/${permissionId}`, permissionData, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Update permission error:', error)
      throw error
    }
  },

  /**
   * Delete permission
   */
  async deletePermission(permissionId: string): Promise<ApiResponse<{ success: boolean; message: string }>> {
    try {
      const response = await apiClient.delete<{ success: boolean; message: string }>(`/auth-service/api/v1/permissions/${permissionId}`, undefined, 'AUTH')
      return response
    } catch (error) {
      console.error('Delete permission error:', error)
      throw error
    }
  }
}
